<template>
    <div class="network">
        <div class="cpwl">
            <ContentBox title="仓配网络" text="覆盖全国县区无盲点，精益自动仓储，精准高效配送，科学路线规划">
                <div class="content">
                    <div>
                        <img src="../../images/icon/cpyt_icon_pszx.png">
                        <h5>117个区域配送中心</h5>
                        <p>共同仓储，共同配送</p>
                    </div>
                    <div>
                        <img src="../../images/icon/cpyt_icon_wd.png">
                        <h5>2500+最后一公里网点</h5>
                        <p>实现大件家电、家居送装一体</p>
                    </div>
                    <div>
                        <img src="../../images/icon/cpyt_icon_fg.png">
                        <h5>无盲点覆盖</h5>
                        <p>全国2875个区县、39862个乡镇</p>
                    </div>
                    <div>
                        <img src="../../images/icon/cpyt_icon_gh.png">
                        <h5>科学路线规划</h5>
                        <p>固定班车路线，省内乡镇直达</p>
                    </div>
                </div>

            </ContentBox>
        </div>
        <div class="bar">
            <div class="cells">
                <div class="cell">
                    <h5>117</h5>
                    <p>配送中心</p>
                </div>
                <div class="cell">
                    <h5>87</h5>
                    <p>FDC</p>
                </div>
                <div class="cell">
                    <h5>23</h5>
                    <p>DC</p>
                </div>
                <div class="cell">
                    <h5>7</h5>
                    <p>RDC</p>
                </div>
            </div>
        </div>
        <div class="cpwlnl">
            <ContentBox title="仓配网络能力" text="">
                <div class="flex">
                    <div class="tab">
                        <div class="tab-list">
                            <div
                                class="tab-inner"
                                v-for="(item,index) in img"
                                :key="index"
                                :class="{on:img[index].show}"
                                @click="showTab(index)"
                            >{{img[index].name}}</div>
                        </div>
                    </div>
                    <div class="box">
                        <viewer v-if="COMMON.isMobile">
                            <img :src="img[index].url">
                        </viewer>
                        <img :src="img[index].url" v-else>
                    </div>
                </div>
            </ContentBox>
        </div>
    </div>
</template>
<style lang="less">
.network {
    .title {
        font-size: 32px;
    }
    img {
        max-width: 100%;
        margin: 0 auto;
    }
    .bar {
        background: #fbfbfb;
        .cells {
            display: flex;
            width: 12rem;
            margin: 0 auto;
            border-right: #f3f3f3 solid 1px;
        }
    }
    .cell {
        flex: 1;
        border-left: #f3f3f3 solid 1px;
        height: 1rem;
        text-align: center;
        h5 {
            color: #ff8b00;
            font-size: 28px;
            margin-top: 0.2rem;
        }
        p {
            color: #333333;
        }
    }
    .cpwl {
        padding: 0.2rem 0 0.3rem 0;
        text-align: center;
        .title {
            color: #333333;
            padding: 0.2rem 0;
        }
        .sub-title {
            font-size: 16px;
            text-align: center;
            line-height: 1.8em;
            padding-bottom: 0.6rem;
        }
        .content {
            display: flex;
            width: 12rem;
            margin: 0 auto;
            div {
                width: 2.5rem;
                flex: 1;
            }
            img{
                margin-bottom:0.36rem;
            }
        }
        h5 {
            color: #333333;
        }
        p {
            line-height: 1.5em;
        }
    }
    .cpwlnl {
        background: #f8f9fa;
        padding-bottom: .8rem;
        .title {
            color: #333333;
            z-index: 10;
            padding-bottom: 0;
            margin: 1em 0;
            padding: 1em 0 0 0;
            text-align: center;
        }
        .flex {
            display: flex;
        }
        .box {
            width: 9rem;
            margin: 0 auto;
        }
        .tab {
            width: 2.2rem;
        }
        .tab-list {
            margin-top: 2rem;
            background: rgba(136, 136, 136, 0.05);
        }
        .tab-inner {
            height: 0.6rem;
            text-align: center;
            line-height: 0.6rem;
            cursor: pointer;
        }
        .on {
            background: #007eff;
            color: #ffffff;
            }
    }
}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .network .cell h5 {
        font-size: 24px;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .network .cell h5 {
        font-size: 20px;
    }
}

@media screen and (max-width: 480px) {
    .network {
        .title {
            font-size: 16px;
        }
        .sub-title {
            font-size: 12px;
        }
        p {
            font-size: 12px;
        }
        .bar {
            .cells {
                width: 100%;
                padding: 0.1rem 0;
            }
        }
        .cell {
            height: auto;
            border-left: 0 none;
            h5 {
                font-size: 18px;
                margin-top: .05rem;
            }
            p {
                padding-bottom: .1rem;
            }
        }
        .cpwl {
            padding: .15rem;
            .title {
                padding: .1rem 0 .2rem 0;
            }
            .sub-title {
                display: none;
            }
            .content {
                width: 100%;
                flex-wrap: wrap;
                img {
                    margin: 0 auto .2rem auto;
                    width: .3rem;
                    height: .3rem;
                }
                div {
                    font-size: 12px;
                    width: 50%;
                    min-width: 50%;
                    padding: .25rem 0.05rem;
                    box-sizing: border-box;
                    border-right: 1px solid #e6e6e6;
                    border-bottom: 1px solid #e6e6e6;
                    &:nth-child(2n) {
                        border-right: 0 none;
                    }
                    &:nth-child(3) {
                        border-bottom: 0 none;
                    }
                    &:nth-child(4) {
                        border-bottom: 0 none;
                    }
                }
            }
            h5 {
                margin: 0 0 .05rem 0;
            }
            p {
                line-height: 1.8em;
            }
        }
        .cpwlnl {
            padding: .2rem .15rem .3rem .15rem;
            .title {
                margin: .5em 0 .2em;
                padding: 0;
                text-align: center;
            }
            p {
                text-align: center;
                font-size: 12px;
                margin: .1rem 0;
            }
            .flex {
                display: block;
            }
            .tab {
                width: 100%;
            }
            .tab-list {
                display: flex;
                margin-top: 0;
                background: none;
            }
            .tab-inner {
                font-size: 14px;
                width: 50%;
                min-width: 50%;
                height: .5rem;
                line-height: .5rem;
                border-bottom: 1px solid #e6e6e6;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                &.on {
                    background: none;
                    color: #0094ff;
                    position: relative;
                    &:after {
                        content: '';
                        display: block;
                        width: .05rem;
                        height: .05rem;
                        border: 1px solid #e6e6e6;
                        border-right: 0 none;
                        border-bottom: 0 none;
                        transform: rotate(45deg);
                        background: #f8f9fa;
                        position: absolute;
                        left: 50%;
                        bottom: -.03rem;
                        margin-left: -.03rem;
                    }
                }
            }
            .box {
                width: 100%;
                margin: .15rem 0 0 0;
            }
        }
    }
}
</style>
<script>
import ContentBox from '../common/content-box';
export default {
    metaInfo: {
        title: '安得智联-仓配网络|一体化解决方案',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联仓配网络,仓配一体化解决方案'
        },{                 // set meta
            name: 'description',
            content: '安得智联仓配网络,为客户提供高效的仓配一体化解决方案,覆盖全国县区无盲点,精益自动仓储,精准配送,科学路由规划.'
        }]
    },
    name: 'network',
    data() {
        return {
            index:0,
            img: [
                { name: '基地仓', show: true, url: require('../../images/picture/cpwl_map.png')},
                { name: '配送中心', show: false, url:require('../../images/picture/cpwl_map_pszx.png')},
                { name: '服务中心', show: false, url:require('../../images/picture/cpwl_map_fwzx.png')}
            ]

        };
    },
    components: {
        ContentBox
    },
    methods: {
        showTab(index) {
            this.img.map(item => {
                item.show = false;
            });
            this.img[index].show = true;
            this.index=index;
        }
    },
    mounted() {
    }
};
</script>